import { GameConfig } from "@/types/game";
import { WeaponType, WeaponConfig } from "@/types/weapons";
import { DemonType, DemonConfig } from "@/types/demons";

export const GAME_CONFIG: GameConfig = {
  DEMON_COUNT: 10,
  MAX_HEALTH: 100,
  BULLET_SPEED: 50,
  BULLET_LIFETIME: 3000,
  RADAR_RANGE: 50,
  RADAR_SIZE: 120,
  DAMAGE_INVULNERABILITY_TIME: 1000,
} as const;

export const WEAPON_CONFIGS: Record<WeaponType, WeaponConfig> = {
  shotgun: {
    name: "Shotgun",
    fireRate: 800,
    damage: 7,
    pellets: 8,
    recoil: 0.6,
    emoji: "🔫",
    maxAmmo: 50,
    spread: 0.3,
  },
  chaingun: {
    name: "Chaingun",
    fireRate: 100,
    damage: 1,
    recoil: 0.2,
    emoji: "⚡",
    maxAmmo: 200,
    spread: 0.1,
  },
  rocket: {
    name: "Rocket Launcher",
    fireRate: 1200,
    damage: 50,
    recoil: 1.0,
    emoji: "🚀",
    maxAmmo: 20,
    splash: 10,
    spread: 0.02,
  },
  plasma: {
    name: "Plasma Rifle",
    fireRate: 200,
    damage: 4,
    recoil: 0.3,
    emoji: "🔥",
    maxAmmo: 100,
    spread: 0.05,
  },
} as const;

export const DEMON_CONFIGS: Record<DemonType, DemonConfig> = {
  IMP: {
    name: "Imp",
    emoji: "👹",
    health: 1,
    speed: 1.0,
    scale: 1.0,
    color: 0x8b4513,
    headColor: 0x654321,
    eyeColor: 0xff0000,
    detectRange: 60,
    attackRange: 3.5,
    chaseRange: 8,
    attackDamage: 10,
    spawnWeight: 100,
  },
  DEMON: {
    name: "Demon",
    emoji: "🐺",
    health: 2,
    speed: 1.8,
    scale: 0.9,
    color: 0x4b0000,
    headColor: 0x8b0000,
    eyeColor: 0xff4400,
    detectRange: 70,
    attackRange: 4.0,
    chaseRange: 10,
    attackDamage: 15,
    spawnWeight: 60,
  },
  CACODEMON: {
    name: "Cacodemon",
    emoji: "👁️",
    health: 4,
    speed: 0.8,
    scale: 1.6,
    color: 0x800080,
    headColor: 0x4b0082,
    eyeColor: 0xff0000,
    detectRange: 80,
    attackRange: 6.0,
    chaseRange: 12,
    attackDamage: 25,
    spawnWeight: 30,
  },
  BARON: {
    name: "Baron of Hell",
    emoji: "👺",
    health: 8,
    speed: 1.2,
    scale: 2.0,
    color: 0x800000,
    headColor: 0x4a0000,
    eyeColor: 0xff0000,
    detectRange: 100,
    attackRange: 8.0,
    chaseRange: 15,
    attackDamage: 40,
    spawnWeight: 10,
  },
  ARCHVILE: {
    name: "Archvile",
    emoji: "🔥",
    health: 6,
    speed: 0.5,
    scale: 1.8,
    color: 0x8b0000,
    headColor: 0xff4500,
    eyeColor: 0xffd700,
    detectRange: 120,
    attackRange: 25.0,
    chaseRange: 20,
    attackDamage: 25,
    spawnWeight: 15,
    isRanged: true,
    fireballSpeed: 15.0,
    fireballRange: 30.0,
  },
} as const;
